export default {"src":"/_next/static/media/sim_icon.bd8c0bf8.svg","height":122,"width":110,"blurWidth":0,"blurHeight":0};